export default __webpack_public_path__ + "static/media/blue-warning.021aed3e.svg";